import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import React, { forwardRef } from 'react';
import { useTheme } from '../../hooks/useTheme.js';
import { LinkBase } from '../LinkBase/index.js';

/*
  Accessible Icon Button
  - add aria-label to button
  - set svg icon to not be focusable to avoid redundant tab stop
*/
var LinkIconButton = forwardRef(function (_a, ref) {
    var children = _a.children, label = _a.label, _b = _a.themeKey, themeKey = _b === void 0 ? "iconButtons" : _b, _c = _a.look, look = _c === void 0 ? "primary" : _c, _d = _a.size, size = _d === void 0 ? "md" : _d, _e = _a.tone, tone = _e === void 0 ? "primary" : _e, _f = _a.rounded, rounded = _f === void 0 ? false : _f, sx = _a.sx, props = __rest(_a, ["children", "label", "themeKey", "look", "size", "tone", "rounded", "sx"]);
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps({ look: look, rounded: rounded, size: size, tone: tone, sx: sx }, {
        themeKey: themeKey,
    });
    return (jsx(LinkBase, __assign({ ref: ref, "aria-label": label, title: label }, forwardProps, props, { children: React.cloneElement(children, {
            focusable: false,
            "aria-hidden": "true",
        }) })));
});
LinkIconButton.displayName = "LinkIconButton";

export { LinkIconButton };
//# sourceMappingURL=index.js.map
